import { SoundType } from '@monorepo/shared/src/providers/ActivityAudioProvider/types';

interface ActivitySoundsMap {
  name: string;
  category: string;
  src: {
    src: string;
    captions: string;
  };
}

export const GameSounds = {
  CHARACTER_AUDIO: (letterToPlay: string) => ({
    name: `letter-${letterToPlay}`,
    category: 'gameSounds',
  }),
};

const SoundOutWordsTransformer = (data: { [key: string]: any }): SoundType[] => {
  const activitySpecificSounds: Array<ActivitySoundsMap> = [];
  data.words?.forEach(
    (word: {
      sounds?: Array<{ description: string; src: string; captions: string }>;
      word?: { description: string; src: string };
    }) => {
      word.sounds?.forEach((sound) =>
        activitySpecificSounds.push({
          name: `letter-${sound.description}`,
          category: 'gameSounds',
          src: {
            src: sound.src,
            captions: sound.captions || '',
          },
        })
      );
    }
  );

  return activitySpecificSounds;
};

export default SoundOutWordsTransformer;
